import { Button, Card } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { setShowConfirmationModal } from "../../store/slices/appSlice";

function ConfirmationModal(props: any) {
    const { t } = useTranslation(["texts", "errors"]);
    const dispatch = useAppDispatch();
    const showConfirmationModal = useAppSelector((state) => state.app.showConfirmationModal);
    const handleOkClick = props.handleOkClick;
    const handleCancelClick = props.handleCancelClick;
    const text = props.confirmationText;

    const toggleConfirmationModal = () => {
        dispatch(setShowConfirmationModal(!showConfirmationModal));
    }

    return (
        <Modal isOpen={showConfirmationModal} toggle={toggleConfirmationModal } className="confirmation-modal">
            <ModalBody>
                <Card>
                    <Row>
                        <Col>
                            {text}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Button variant="contained" onClick={handleOkClick}>
                                {t("OK")}
                            </Button>
                        </Col>
                        <Col>
                            <Button variant="contained" onClick={handleCancelClick} className="pull-right">
                                {t("Cancel")}
                            </Button>
                        </Col>
                    </Row>
                </Card>
            </ModalBody>
        </Modal>
    );
}

export default ConfirmationModal;
